<ion-header>
  <ion-toolbar color="white-0">
    <ion-title></ion-title>
    <ion-buttons slot="end">
      <app-modal-back
        (click)="storeFeedback()"
        icon="close"
        ariaLabel="close"
      ></app-modal-back>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="ion-padding-horizontal">
    <h2 class="h2">What could we do better?</h2>
    <p>
      We’re sorry to hear you are not enjoying the experience on the Mable app. Please share what we can do to improve.
    </p>
  </div>
  <form
    [formGroup]="feedbackForm"
    (ngSubmit)="sendFeedback()"
    [class.submitted]="isSubmitted"
  >
    <mable-input
      label="How can we improve?"
      [isRequired]="true"
    >
      <ion-textarea
        rows="4"
        autocapitalize="sentences"
        [maxlength]="messageMaxLengthLimit"
        formControlName="message"
      ></ion-textarea>
      <div class="warn">
        <p *ngIf="feedbackForm.controls.message.errors?.required">Feedback can't be blank</p>
        <p *ngIf="feedbackForm.controls.message.errors?.minlength">Enter min 25 characters.</p>
      </div>
      <div class="info">
        <ion-row>
          <ion-col size="8">Maximum {{ messageMaxLengthLimit }} characters</ion-col>
          <ion-col class="ion-text-right">{{ feedbackForm.value.message.length }}/{{ messageMaxLengthLimit }}</ion-col>
        </ion-row>
      </div>
    </mable-input>
    <div class="ion-padding-horizontal">
      <mable-button
        expand="block"
        class="ion-margin-bottom"
        buttonType="submit"
      >
        Submit
      </mable-button>
      <mable-button
        expand="block"
        category="outline"
        (onClick)="dismiss()"
      >
        Dismiss
      </mable-button>
    </div>
  </form>
</ion-content>
